import { defineStore } from 'pinia';
import type { User } from '@/entities/user/model/types/user';

export const useUserStore = defineStore('user', () => {
  const { $userService } = useNuxtApp();
  const accessToken = useCookie('ECOM_ACCESS_TOKEN', { path: '/' });
  const refreshToken = useCookie('ECOM_REFRESH_TOKEN', { path: '/' });
  const selectedAddressCookie = useCookie('ECOM_SELECTED_ADDRESS', { path: '/' });

  const user = ref<User | object>({});
  const isAuth = ref<boolean>(false);

  const getUser = async (): Promise<void> => {
    try {
      const { data }: { data: User } = await $userService.getUser();

      if (Object.keys(data).length) {
        user.value = data;
        isAuth.value = true;
      }
    } catch (error) {
      console.error('Ошибка при получении данных профиля:', error);
    }
  };

  const setUser = (data: User): void => {
    user.value = data;
  };

  const setIsAuth = (value: boolean): void => {
    isAuth.value = value;
  };

  const logout = (): void => {
    user.value = {};
    isAuth.value = false;
    accessToken.value = null;
    refreshToken.value = null;
    selectedAddressCookie.value = null;
    navigateTo('/');
  };

  return {
    user,
    isAuth,
    logout,
    getUser,
    setUser,
    setIsAuth,
  };
});
